import React from 'react';
import {makeStyles} from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
    layout: {
        borderRadius: '12px',
        borderWidth: '0px',
        backgroundColor: theme.palette.background.default,
        boxShadow: '0 3px 2px 0 rgba(0,0,0,0.1)',
        paddingLeft: '25px',
        paddingRight: '25px',
        textTransform: 'uppercase',
        fontFamily: theme.typography.fontFamily,
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: theme.palette.background.default,
            boxShadow: '0 3px 12px 0 rgba(0,0,0,0.1)',
        },
        '&:active': {
            cursor: 'pointer',
            backgroundColor: '#E6E6E6',
            boxShadow: 'none',
        },
        '&:focus': {
            /*outline: '0 !important',*/
        },
    },
    variantBig: {
        '&.paragraph3': {
            color: '#17171A',
            fontWeight: 'bold',
        },
        height: '44px',
    },
    variantNormal: {
        '&.paragraph4': {
            color: '#17171A',
            fontWeight: 'bold',
        },
        height: '34px',
    },
}));

export default function PrimaryBasicInverseButton(props) {
    const { title, variant, className, onClick } = props;
    const classes = useStyles();

    return (
        <button
            className={clsx(variant === 'big' ? clsx('paragraph3', classes.variantBig) : clsx('paragraph4', classes.variantNormal), classes.layout, className)}
            onClick={onClick}
        >
            {title}
        </button>
    );
}
